import  './SaveTest_table_new.scss';
import * as S from '../scss/theme';
import Button from '../comm/HongButton';
import { Checkbox } from '@mui/material';
import React, { useState, useEffect, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
// import { setIsHidden_saveTest, setCartListAll, setIsRemake, setTestCodeMunObj, setIsTakeExam} from "../reduxToolkit/redux";
import fnc from '../mymod/commFunction';
import fncS4 from '../mymod/commFunction4';
import { useNavigate } from 'react-router-dom';
import { setIsModalSaveTest, setIsModalSaveTestNew, setListCart } from '../reduxToolkit/redux';
import Img2pdf from '../img2pdf/Img2pdf';


const SaveTest_table_new = ({selectedNodeId, setTestCnt, nthNode, setIsFastSearch}) => {

    const dispatch = useDispatch();
    const navigate = useNavigate();

    const userInfo = useSelector(state => state.reduxStore.userInfo);
    const listCart = useSelector(state => state.reduxStore.listCart);

    const [isModal, setIsModal] = useState(false);
    const [imgList, setImgList] = useState([]);

    const [list, setList] = useState([]);
    const [isSelectAll, setIsSelectAll] = useState(false);
    const [isRefresh, setIsRefresh] = useState(false);

    const [testCode, setTestCode] = useState(''); 
    const [testName, setTestName] = useState(''); 
    const [etc, setEtc] = useState(''); 


    const [munCnt, setMunCnt] = useState(0);
    // const [munCntR, setMunCntR] = useState(0);
    // const [munSum, setMunSum] = useState(0);


    useEffect(() => {
        fncSlectList();
    }, [isRefresh, selectedNodeId]);



    function fncSlectList() {

        const nodeKey = selectedNodeId;  
        if (!nodeKey) return;//펼칠때? undefined
        fnc.sendAxios('/saveTestRoutesNew/main/select/testRecord', { nodeKey }, (res) => {

            if (res) {
                setList(getRecords_list(res));  
                setTestCnt(res.length);      
            } else {
                alert('실패했습니다.');
            }
        });
    }
    

  function getRecords_list(res) {
    let records = [];
    if (!Array.isArray(res)) {
      return records;
    }

    res.forEach(item => {
      const sno = item["sno"];  
      const nodeKey = item["nodeKey"];  
      const gangsaCode = item["gangsaCode"];
      const gangsaName = item["gangsaName"];
      const testCode = item["testCode"];
      const testName = item["testName"];
      const munCnt = item["munCnt"];
      const etc = item["etc"];
      let sDate = item["sDate"];
      sDate = fnc.formatDate2(sDate);
      let eDate = item["eDate"];  
      const postCnt = item["postCnt"];
      const isPost = postCnt > 0 ? 'Y' : ''; // 게시 여부
      const isChecked = false;

      records.push({ sno, nodeKey, gangsaCode, gangsaName, testCode, testName, munCnt, 
        etc, sDate, eDate, isPost, isChecked });
    });

  return records;
  }


  
 //---------------------------checkbox
 function handleCheckboxChange(event, index) {
    const isChecked = event.target.checked;
    const newList = [...list];
    newList[index].isChecked = isChecked;
    setList(newList);

     // 모두 체크되었는지 확인하여 헤더 체크박스 상태 업데이트
    const allChecked = newList.every(item => item.isChecked);
    setIsSelectAll(allChecked);
    }

    function handleSelectAllChange() {
        const newList = list.map(item => ({...item, isChecked: !isSelectAll }));
        setList(newList);
        setIsSelectAll(!isSelectAll);
    }//checkbox END

    
    //----------------------------------------menu
    const handleChange = (event) => {
        setTestName(event.target.value); // 입력값을 상태에 업데이트
    };

    const handleChangeEtc = (event) => {
        setEtc(event.target.value); // 입력값을 상태에 업데이트
    };

    //----------------------------------------
    function onAdd() {//추가

        if (!nthNode) {
            alert('노드를 선택하세요!');
            return;
        } else if (nthNode !== 6) {
            alert('6단계 노드에 저장해야 학생에게 게시할 수 있습니다.');
            return;
        }
          




        const nodeKey = selectedNodeId || '';
        const gangsaCode = userInfo.stCode || '';
        const gangsaName = userInfo.name || '';
        const testCode = fnc.fncSirialNum('S');
        const munCnt = listCart.length;
        const sDate = fnc.fncDate();

        if (munCnt === 0) {
            alert('장바구니에 문제가 없습니다.');
            return;
        }

        if (!nodeKey) {
            alert('저장폴더를 선택하세요!');
            return;
        }
        
        const sqlValues = listCart.map((item, index) => `('${testCode}', '${item.문항번호}', ${index + 1})`) // Map each object to SQL row
        .join(', '); // Join with commas

         fnc.sendAxios('/saveTestRoutesNew/main/insert/testRecord/munCode', { sqlValues }, (res) => {     
            if (res.rowCount > 0) {
                fncInsert_saveTest_main(nodeKey, gangsaCode, gangsaName, testCode, munCnt, sDate);//testNm 추가
            } else {
                alert('실패했습니다.');
            }
        });    

        
        function fncInsert_saveTest_main(nodeKey, gangsaCode, gangsaName, testCode, munCnt, sDate) {//내부에 둬도 된다.(가독성)
            fnc.sendAxios('/saveTestRoutesNew/main/insert/testRecord', 
               { nodeKey, gangsaCode, gangsaName, testCode, testName, munCnt, etc, sDate }, (res) => {
               if (res.rowCount === 1) {
                   setIsRefresh(!isRefresh);
               } else {
                   alert('실패했습니다.');
               }
           });
       }

    }

    function onUpdate() {//수정
        if (!testCode) {
            alert('시험지를 선택하세요!');
            return;
        }

        fnc.sendAxios('/saveTestRoutesNew/main/update/testRecord', { testCode, testName, etc }, (res) => {
            if (res.rowCount === 1) {
                setIsRefresh(!isRefresh);
            } else {
                alert('실패했습니다.');
            }
        });
    }

    function onDelete() {//삭제
        const selectedCnt = list.filter(item => item.isChecked).length;
        const testCodes = list.filter(item => item.isChecked).map(item => item.testCode).join(','); 
        
        if (selectedCnt === 0) {
            alert('삭제할 대상을 체크박스로 선택하세요!');
            return;
        }
      
        const rtn = window.confirm(`${selectedCnt}개의 시험지를 삭제하시겠습니까?`);
        if (!rtn) return;

        fnc.sendAxios('/saveTestRoutesNew/main/deleteUpdate/testRecord', { testCodes }, (res) => {
            if (res.rowCount > 0) {
                setIsRefresh(!isRefresh);
            } else {
                alert('실패했습니다.');
            }
        });
    }

  
    function onClose() {
        dispatch(setIsModalSaveTestNew(false));
    }

    function onRowClick(item, index) {//tr

        setTestName(item.testName);
        setEtc(item.etc);
        setTestCode(item.testCode);
        setMunCnt(item.munCnt);

        const newList = list.map(item => ({...item, isChecked: false }));
        setIsSelectAll(false);
        newList[index].isChecked = true;
        setList(newList);
  
    }

    function onReMake() {//=================재출제
        if (!testCode) {
            alert('시험지를 선택하세요!');  
            return;
        }

        fncSelectList_reMake(testCode, (updateRes) => {
            if (Array.isArray(updateRes) && updateRes.length > 0) {
                dispatch(setListCart(updateRes));
                 navigate('/munMaual');
                
                onClose();
            }
        });
    }


    function fncSelectList_reMake(testCode, callback) {   
        fnc.sendAxios('/saveTestRoutesNew/remake/selectMunList_classic', { testCode }, (res) => { 
          if (res) {
            const updateRes = getRecords_list(res);
            callback(updateRes);          
          } else {
            console.log("속성이 obj 내에 없습니다.");
          }
        });

          function getRecords_list(res) {
            return res.map(item => ({
                시험지명: item["시험지명"],
                문항번호: item["문항번호"],
                연번: item["연번"],
                no: item["no"],
                정답: item["정답"],
                Img단: item["Img단"],
                imgSize: item["imgSize"],
                imgSizeSol: item["imgSizeSol"],
                이미지코드: item["이미지코드"],
                대단원: item["대단원"],
                중단원: item["중단원"],
                소단원: item["소단원"],
                유형: item["유형"],
                폴더: item["폴더"],
                난이도: item["난이도"],
                난이도Idx: item["난이도Idx"],
                공통지문: item["공통지문"],
                문풀답: item["문풀답"],
                isSelected: false 
            }));
        }

      }


    function onClickPreview_total() { //미리보기

        fncSelectList_reMake(testCode, (updateRes) => {
            if (Array.isArray(updateRes) && updateRes.length > 0) {
               onClickPreview(updateRes);
            }
        });
    }

      
    async function onClickPreview(listCart) {

        if (listCart.length === 0) {  
        alert('장바구니에 문제가 없습니다.');
        return;
        } 
    
        try {
        const imgListNew = await getRecords_detail_que(listCart); // await 추가
        setImgList(imgListNew);
        setIsModal(true);
        } catch (error) {
        console.error('이미지 로딩 실패:', error);
        alert('이미지를 불러오는데 실패했습니다.');
        }
    }
    
    
    async function getRecords_detail_que(listCart) {
    
        const records = [];
        const insertCommFileArray = [];
        
        try {
        for (let i = 0; i < listCart.length; i++) {
    
            const imgUrl = process.env.REACT_APP_imgUrl_S3;//web/kuesbImageLms
            const acaCode = fnc.getCookie('s3_acaCode');//이거 확인 하도록
            const folder = listCart[i]['폴더'].replaceAll('\\', '/');
            const imgFileName = listCart[i]['이미지코드'];
            const commQue = listCart[i]['공통지문'];
            
            let imagePath = await fncS4.getS3Path( `${imgUrl}/${acaCode}/${folder}/${imgFileName}`);   
            let imagePath_sol = await fncS4.getS3PathLong( `${imgUrl}/${acaCode}/${folder}/풀이_${imgFileName}`);
            let imagePath_comm = '';
            let kind = 'q'; // 모든 이미지를 문제로 처리
            if (commQue) {
                imagePath_comm = await fncS4.getS3PathLong( `${imgUrl}/${acaCode}/${folder}/${commQue}.gif`);
                kind = '@'; 
            } else {
                imagePath_comm ='';
            }
    
    
                if (imagePath_comm && !insertCommFileArray.includes(commQue)) {//공통지문이 있고, 아직 추가되지 않은 경우
                records.push({
                    imagePath: imagePath_comm,
                    imagePath_sol,
                    imagePath_comm,
                    문항번호: listCart[i]['문항번호'],
                    유형: listCart[i]['유형'],
                    kind: '@'
                });
    
                insertCommFileArray.push(commQue);
                }
    
            
            records.push({//문제
                imagePath,
                imagePath_sol,
                imagePath_comm,
                문항번호: listCart[i]['문항번호'],
                유형: listCart[i]['유형'],
                kind: 'q'
            });
    
        }
        
        return records;
        
        } catch (error) {
        console.error('getRecords_detail_que 에러:', error);
        throw error;
        }
    }
    
    function onPost() {//게시

        const testCodeNm = fnc.fncSirialNum('NM');
        const acaCode = fnc.getCookie('acaCode');//이거 확인 하도록

        if (!testCode) {    
            alert('시험지를 선택하세요!');
            return;
        }
        const rtn = window.confirm('게시하시겠습니까?');
        if (!rtn) return;   
        fnc.sendAxios('/kuesbExamRoutes/save/st_test_nm_two/post', { acaCode, testCode, testName, testCodeNm, munCnt }, (res) => {

            if (res.rowCount === 1 || res.success) {
                setIsRefresh(!isRefresh);
                // alert('완료되었습니다.');
            
            } else {
                alert('게시 실패했습니다.');
            }
        });
    }


    
    function onPostDelete() {//게시삭제

        if (!testCode) { //시험지코드mun
            alert('시험지를 선택하세요!');
            return;
        }
        const rtn = window.confirm('게시를 취소하시겠습니까?');
        if (!rtn) return;   
        fnc.sendAxios('/kuesbExamRoutes/delete/st_test_nm_two/post', { testCode }, (res) => {

            if (res.rowCount === 1 || res.success) {
                // alert('완료되었습니다.');
                setIsRefresh(!isRefresh);
            } else {
                alert('실패했습니다.');
            }
        });
    }

   
    //==================================
    return(
     
        <div className="SaveTest_table_new">
            <section className='section-menu'>
                
                <article className='article-input'>
                    <div className='box-input'>
                        <span className='lbl-input'>시험지명</span>
                        <input className='txt' type="text" value={testName} onChange={handleChange} spellCheck="false" autoComplete="off"/>
                    </div>
                    <div className='box-input'>
                        <span className='lbl-input'>비고</span>
                        <input  className='txt' type="text" value={etc} onChange={handleChangeEtc} spellCheck="false" autoComplete="off"/>
                    </div>
                </article>
               
                <article className='article-button'>
                    <Button className='btn h-btn-blue' onClick={onAdd}>추가</Button>
                    <Button className='btn h-btn-sky' onClick={onUpdate}>수정</Button>
                    <Button className='btn h-btn-red' onClick={onDelete}>삭제</Button>
                    <Button className='btn h-btn-green' onClick={onReMake}>재출제</Button>
                     <Button className='btn h-btn-dark'  onClick={onClickPreview_total}>미리보기</Button>
                    <Button className='btn h-btn-gray' onClick={onPost}>게시</Button>
                    <Button className='btn h-btn-gray' onClick={onPostDelete}>게시취소</Button>
                    <Button className='btn h-btn-gray' onClick={onClose}>닫기</Button>
                </article>
            </section>

            <section className="section-table">
                <table className="table-hong table-main">
                    <thead>
                        <tr>
                            <th>no</th>
                            <th>시험지명</th>
                            <th>문항수</th>                        
                            <th>출제일</th>
                            <th>비고</th>
                            <th>게시</th>
                            <th>
                                <Checkbox className='custom-checkbox'checked={isSelectAll} onChange={handleSelectAllChange} />
                            </th>
                
                        </tr>            
                    </thead>

                    <tbody>

                        { list.map((item, index) => {
                            return(  
                            <tr 
                                key={index} 
                                className={item.isChecked ? 'selected' : ''} 
                                onClick={() => onRowClick(item, index)}
                            >
                                <td>{index+1}</td>
                                <td>{item.testName}</td>
                                <td>{item.munCnt}</td> 
                                <td>{item.sDate}</td> 
                                <td>{item.etc}</td> 
                                <td>{item.isPost}</td>
                             
                                <td>
                                    <Checkbox className='custom-checkbox'
                                        checked={item.isChecked}
                                        onChange={(event) => handleCheckboxChange(event, index)}
                                    />
                                </td>

                            
                            </tr>);
                        })}
                        

                    </tbody>
        
        
                </table>
              
        </section>

          {isModal && <S.Modal_fixed>
                <Img2pdf imgList={imgList} setIsModal={setIsModal} />
            </S.Modal_fixed>}
        
    </div>
  
    );
}

export default SaveTest_table_new;